// extracted by mini-css-extract-plugin
export default {"wrapper":"ClampedActionContent_wrapper__SDbgy","content":"ClampedActionContent_content__c3DNr","toggle":"ClampedActionContent_toggle__gpgEf"};